import getUser from "./getUser.ts";
import deleteCartItem from "./deleteCartItem.ts";
import logout from "./logout.ts";
import postCartItem from "@/redux/slices/user/thunks/postCartItem";
import tryLogin from "@/redux/slices/user/thunks/tryLogin";
import getUserVoip from "@/redux/slices/user/thunks/getUserVoip";
import getAddresses from "@/redux/slices/user/thunks/getAddresses";
import getCallCredit from "@/redux/slices/user/thunks/getCallCredit";
import getPaymentOptions from "@/redux/slices/user/thunks/getPaymentOptions";
import getCartToken from "@/redux/slices/user/thunks/getCartToken";
import postAddress from "@/redux/slices/user/thunks/postAddress";
import getCart from "@/redux/slices/user/thunks/getCart";
import updateCartItem from "@/redux/slices/user/thunks/updateCartItem";

const thunks = [
  getUserVoip,
  tryLogin,
  getUser,
  deleteCartItem,
  postCartItem,
  getAddresses,
  updateCartItem,
  getCallCredit,
  getPaymentOptions,
  getCartToken,
  postAddress,
  getCart,
  logout,
];

export default thunks;
